// https://www.npmjs.com/package/intl-tel-input
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

class IntlTelInput {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        const inputPhone = this.elem.querySelector("input[type='text']");
        if(inputPhone) {
            //anchor the last added phone field to the window object so we can force the initial language
            //TODO: If we need this to work for multiple fields this needs to be expanded to an array!
            window.intl_phone = intlTelInput(inputPhone, {
                initialCountry      : ( window.curLang === 'en' ? 'us' : window.curLang ),
                nationalMode        : false,
                preferredCountries  : ['de', 'us', 'gb', 'fr' ]
            });
        }
    }
}

export default IntlTelInput;
